<template>
  <div class="share-place-widget">
    <div class="title-bar">
      <label>{{ $t('SharePlaceWidget.share') }}</label>
      <button class="close-button" @click="clickCloseBtn">
        <img :src="util.getImagePath('x_blue@2x.png')" :srcset="util.getImageSet('x_blue')">
      </button>
    </div>
    <div class="app-list">
      <div class="button-group">
        <button class="copy-url" @click="copyLink">
          <img :src="util.getImagePath('copy_blue@2x.png')" :srcset="util.getImageSet('copy_blue')" >
        </button>
        <label>{{ $t('SharePlaceWidget.copy') }}</label>
      </div>
      <div class="button-group">
        <button @click="clickQrButton">
          <img :src="util.getImagePath('qr_share_blue@2x.png')" :srcset="util.getImageSet('qr_share_blue')" >
        </button>
        <label>{{ 'QR Code' }}</label>
      </div>
      <div class="button-group" v-if="showLineButton">
        <button @click="clickLineButton">
          <img :src="util.getImagePath('share_line@2x.png')" :srcset="util.getImageSet('share_line')">
        </button>
        <label>{{ 'LINE' }}</label>
      </div>
      <div class="button-group" v-if="showFacebookButton">
        <button @click="clickFacebookButton">
          <img :src="util.getImagePath('share_facebook@2x.png')" :srcset="util.getImageSet('share_facebook')">
        </button>
        <label>{{ 'Facebook' }}</label>
      </div>
      <div class="button-group">
        <button @click="clickGoogleMapButton">
          <img :src="util.getImagePath('google_map@2x.png')" :srcset="util.getImageSet('google_map')">
        </button>
        <label>{{ 'Google Maps' }}</label>
      </div>
      <div class="button-group" v-if="isMacIOS">
        <button @click="clickAppleMapButton">
          <img :src="util.getImagePath('apple_map@2x.png')" :srcset="util.getImageSet('apple_map')">
        </button>
        <label>{{ 'Apple Map' }}</label>
      </div>
      <div class="button-group">
        <button class="embeded" @click="htmlLink">
          <img class="left" :src="util.getImagePath('arrow_up_blue@2x.png')" :srcset="util.getImageSet('arrow_up_blue')" >
          <img class="right" :src="util.getImagePath('arrow_up_blue@2x.png')" :srcset="util.getImageSet('arrow_up_blue')" >
        </button>
        <label>{{ 'Embeded' }}</label>
      </div>
      <div class="button-group">
        <button @click="clickUserButton">
          <img :src="util.getImagePath('scan_qr_blue@2x.png')" :srcset="util.getImageSet('scan_qr_blue')" >
        </button>
        <label>{{ 'User Code' }}</label>
      </div>
      <div class="button-group" v-if="showMoreButton">
        <button @click="clickMoreButton">
          <img :src="util.getImagePath('more_share@2x.png')" :srcset="util.getImageSet('more_share')" >
        </button>
        <label>{{ 'More' }}</label>
      </div>
      <!-- <button @click="clickGrabButton">
        <img :src="util.getImagePath('grab@2x.png')" :srcset="util.getImageSet('grab')">
      </button> -->
      <!-- <button>
        <img :src="util.getImagePath('all_thai_taxi@2x.png')" :srcset="util.getImageSet('all_thai_taxi')">
      </button> -->
    </div>
    <div class="link">
      <input ref="share-url-input" type="link" :value="placeUrl" @click="clickLink" readonly>
      <button @click="copyLink" v-html="$t('SharePlaceWidget.copy')"></button>
      <transition name="fade">
        <div class="copied" v-if="isShowCopied" v-html="$t('SharePlaceWidget.copy')"></div>
      </transition>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers'

export default {
  name: 'SharePlaceWidget',
  props: {
    placeDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      isShowCopied: false
    }
  },
  computed: {
    placeUrl () {
      var self = this
      return `${window.location.origin}/p/${self.placeDetail.promptpai_id}`
    },
    isMacIOS () {
      return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
    },
    showMoreButton () {
      return 'share' in window.navigator || this.util.getUserAgentMeta() === 'Android application'
    },
    showFacebookButton () {
      return this.util.getUserAgentMeta() !== 'Android application'
    },
    showLineButton () {
      return this.util.getUserAgentMeta() !== 'Android application'
    },
    isInLineBrowser () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (window.liff) {
        if (userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
          return window.liff.isInClient()
        }
      }
      return false
    }
  },
  methods: {
    clickCloseBtn () {
      var self = this
      self.$router.back()
    },
    clickLink () {
      var self = this
      var copyText = self.$refs['share-url-input']
      copyText.select()
    },
    copyLink () {
      var self = this
      var copyText = self.$refs['share-url-input']
      copyText.select()
      document.execCommand('Copy')
      self.isShowCopied = true
      setTimeout(() => {
        self.isShowCopied = false
      }, 2000)
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `copy_url_${self.placeDetail.promptpai_id}`})
    },
    htmlLink () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `${window.location.origin}/ws/tools?pp_id=${self.placeDetail.promptpai_id}#permalink-button`
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `embeded_html_${self.placeDetail.promptpai_id}`})
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url)
      }
    },
    clickQrButton () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'PlaceQrCard',
        placeDetail: self.placeDetail
      })
    },
    clickUserButton () {
      var self = this
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `scan_user_qr_${self.placeDetail.promptpai_id}`})
      self.$root.$emit('openModal', {
        name: 'QrReader',
        isReadPlace: false,
        selectedPromptpaiId: self.placeDetail.promptpai_id
      })
    },
    clickFacebookButton () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://www.facebook.com/sharer/sharer.php?u=${self.placeUrl}`
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `facebook_${self.placeDetail.promptpai_id}`})
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.sharefacebook?url=${encodeURIComponent(url)}`
      } else if (self.isInLineBrowser) {
        window.liff.openWindow({
          url: url,
          external: true
        })
      } else {
        window.open(url)
      }
    },
    clickLineButton () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://line.me/R/msg/text/?${self.placeUrl}`
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `line_${self.placeDetail.promptpai_id}`})
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (self.isInLineBrowser) {
        window.liff.openWindow({
          url: url,
          external: true
        })
      } else {
        window.open(url)
      }
    },
    clickGoogleMapButton () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://www.google.com/maps/search/?api=1&query=${self.placeDetail.promptpai_location.lat},${self.placeDetail.promptpai_location.lon}`
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `google_maps_${self.placeDetail.promptpai_id}`})
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else if (self.isInLineBrowser) {
        window.liff.openWindow({
          url: url,
          external: true
        })
      } else {
        window.open(url)
      }
    },
    clickAppleMapButton () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://maps.apple.com/?q=${self.placeDetail.promptpai_location.lat},${self.placeDetail.promptpai_location.lon}`
      window.gtag('event', 'share', {'event_category': 'engagement', 'event_label': `apple_map_${self.placeDetail.promptpai_id}`})
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (self.isInLineBrowser) {
        window.liff.openWindow({
          url: url,
          external: true
        })
      } else {
        window.open(url)
      }
    },
    clickMoreButton () {
      var self = this
      if (self.util.getUserAgentMeta() === 'Android application') {
        Android.more(self.placeUrl)
      } else {
        window.navigator.share({
          title: 'Share PromptPai',
          url: self.placeUrl
        }).then(() => {
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    clickGrabButton () {
      // var self = this
    }
  }
}
</script>

<style scoped>
  .share-place-widget {
    background-color: rgb(249, 249, 249);
    border-radius: 10px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    padding: 5px;
    box-sizing: border-box;
  }

  .title-bar {
    height: 32px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  label {
    font-size: 18px;
    text-align: left;
    flex-grow: 1;
    padding: 0px 10px 0px 10px;
    font-family: Prompt;
  }

  button.close-button {
    border: none;
    background-color: transparent;
    height: 24px;
    height: 24px;
    cursor: pointer;
    padding: 0px;
    outline: none;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  button.close-button > img {
    height: 24px;
    width: 24px;
    display: block;
  }

  .app-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 6px;
  }

  .app-list > .button-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(100% / 5);
  }

  @media only screen and (max-width: 768px) {
    .app-list > .button-group {
      width: 85px;
    }
  }

  @media only screen and (max-width: 480px) {
    .app-list > .button-group {
      width: calc(100% / 4);
    }
  }

  .app-list > .button-group > label {
    text-align: center;
    font-size: 14px;
  }

  .app-list > .button-group > button {
    height: 48px;
    width: 48px;
    margin: 6px;
    cursor: pointer;
    border: none;
    background-color: transparent;
    padding: 0px;
    outline: none;
  }

  .app-list > .button-group > button.copy-url {
    border: 1px solid rgb(59, 144, 255);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .app-list > .button-group > button.copy-url > img {
    width: 24px;
    height: 24px;
  }

  .app-list > .button-group > button.embeded {
    border: 1px solid rgb(59, 144, 255);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .app-list > .button-group > button > img {
    height: 48px;
    width: 48px;
    display: block;
  }

  .app-list > .button-group > button.embeded > img {
    width: 16px;
    height: 16px;
  }

  .app-list > .button-group > button.embeded > img.left {
    transform: rotate(-90deg);
    margin-right: -2px;
  }

  .app-list > .button-group > button.embeded > img.right {
    transform: rotate(90deg);
    margin-left: -2px;
  }

  .link {
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-direction: row;
  }

  .link > input {
    border: 1px solid rgb(204, 204, 204);
    border-radius: 4px 0px 0px 4px;
    height: 32px;
    flex: 1;
    outline: none;
    padding: 5px;
    color: rgb(74, 74, 74);
    box-sizing: border-box;
    width: calc(100% - 75px - 16px - 75px);
    appearance: none;
  }

  .link > button {
    border-radius: 0px 4px 4px 0px;
    background-color: rgb(59, 144, 255);
    cursor: pointer;
    outline: none;
    padding: 0px 10px;
    height: 32px;
    border: none;
    color: rgb(255, 255, 255);
    width: 75px;
  }

  .link > button.html-link {
    border-radius: 4px 4px 4px 4px;
    margin-left: 16px;
  }

  .copied {
    position: absolute;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 0, 0, 0.75);
    width: fit-content;
    border-radius: 16px;
    width: 75px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    left: calc(50% - 37.5px);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media only screen and (max-width: 768px) {
    .share-place-widget {
      border-radius: unset;
      max-width: unset;
      width: 100%;
      align-self: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SharePlaceWidget.vue